import axios from 'axios';
const { handleOAuthFlow } = require('./oauth_flow');

const nexum_sym = process.env.REACT_APP_NEXUM_SYM;
const nexum_api_key = process.env.REACT_APP_NEXUM_API_KEY;
const nexum_dev_endpoint = process.env.REACT_APP_NEXUM_DEV_ENDPOINT;
const nexum_ac = process.env.REACT_APP_NEXUM_AC;

const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT;
const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

const ms_isrb_key = process.env.REACT_APP_MS_ISRB_KEY;


// Utility function to get account number
const getMemberInfo = async () => {
  const timeout = 5000;
 
  // Check for existing authentication
  const existingAuth = sessionStorage.getItem('auth_data');
  if (existingAuth) {
    try {
      const authData = JSON.parse(existingAuth);
      if (!authData.expires_at || Date.now() > authData.expires_at) {
        sessionStorage.removeItem('auth_data');
        // Optionally, trigger re-auth here
      } else {
        return authData;
      }
    } catch (e) {
      sessionStorage.removeItem('auth_data');
    }
  }
 
  // Get query parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
 
  try {
    // Validate required parameters
    if (!plugin_client_id || !plugin_client_secret || !plugin_environment) {
        throw new Error('Missing required parameters');
    }
 
    // Create a promise that rejects after timeout
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(`Request timed out after ${timeout}ms`));
        }, timeout);
    });
 
    const req = {
      code: code,
      state: state
    }
 
    const requestPromise = handleOAuthFlow({
      plugin_environment,
      plugin_client_id,
      plugin_client_secret,
      plugin_redirecturi,
      req
    });
    // Race between the timeout and the actual request
    const result = await Promise.race([requestPromise, timeoutPromise]);
   
    if (result) {
      if (result.results === 'OK'){
        // Store the successful authentication data                                                                
        const expiresIn = result.expires_in || 3600; // seconds, fallback to 1 hour
        const expiresAt = Date.now() + expiresIn * 1000;
        const authDataWithExpiry = { ...result, expires_at: expiresAt };
        sessionStorage.setItem('auth_data', JSON.stringify(authDataWithExpiry));
        return result;
      } else if (result.results === 'ERROR'){
          throw new Error(result.error);
      } else {
          // Store state and code_verifier in sessionStorage
          sessionStorage.setItem(`STATE_${result.state}`, result.code_verifier);
          // Redirect to the authorization URL
          window.location.href = result.redirect_url;
          return null;        
      }
    }
  } catch(error) {
      return {
          results: "ERROR",
          error: error.message,
          member_number: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          user_type: "",
          user_name: "",
          phone_number: ""
  };
};
};
const config = {
  headers: {
    'Authorization': `Bearer ${nexum_api_key}`,
    'Content-Type': 'application/json'
  }
};


export const fetchMemberData = async () => {
  let member_info;
  try {
     member_info = await getMemberInfo();
     console.log("Member Info:", member_info);
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
    return member_info;
  }
  catch (error) {
    throw error;
  }
};

export const fetchDashboardData = async () => {
  let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }

    const nexum_body = {
      "Credentials": {
        "AdministrativeCredentials": {
            "Password": nexum_ac
        }
      },
      "Header": {
          "MessageID": "1",
          "RGState": "GETBTNS"
      },
      "Body": {
          "File": "RHD.SYMX.ADDSHARE.PND",
          "RGSession": 1,
          "UserDefinedParameters": {
              "RGUserChr": [
                  {
                      "ID": "1",
                      "Value": member_info.member_number.padStart(10,"0")
                  }
              ]
          }
      }
    };

    const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
    const response = await axios.post(url, nexum_body, config);
    return JSON.parse(response.data.Body.RGLines);
  } catch (error) {
    throw error;
  }
};

export const fetchShareData = async () => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "GETSHARES"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const fetchCertData = async () => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "GETCERT"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const confirmCertData = async ({certType,certDeposit,certFundFrom}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "GETCERTCONFIRM"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": certType
                      },
                      {
                          "ID": "3",
                          "Value": certDeposit
                      },
                      {
                          "ID": "4",
                          "Value": certFundFrom
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const submitCertCreate = async ({certType,certDeposit,certFundFrom,certDivPost}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "CERTCREATE"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": certType
                      },
                      {
                          "ID": "3",
                          "Value": certDeposit
                      },
                      {
                          "ID": "4",
                          "Value": certFundFrom
                      },
                      {
                          "ID": "5",
                          "Value": certDivPost
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const submitClubCreate = async ({clubName,clubDeposit,clubFundFrom}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "CLUBCREATE"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": clubName
                      },
                      {
                          "ID": "3",
                          "Value": clubDeposit
                      },
                      {
                          "ID": "4",
                          "Value": clubFundFrom
                      }
                    
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const fetchMmData = async () => {
  let member_info;
  try {
    member_info = await getMemberInfo(); 
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "GETMM"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const submitMmCreate = async ({mmDeposit,mmFundFrom}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "MMCREATE"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": mmDeposit
                      },
                      {
                          "ID": "3",
                          "Value": mmFundFrom
                      },
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const fetchChkData = async () => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "GETCHKOPTIONS"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const confirmChkData = async ({selectedChk,chkOpt1,chkOpt2,chkOpt3,chkOpt4}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "CHKCONFIRM"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": selectedChk
                      }
                      
                  ],
                  "RGUserNum": [
                    {
                        "ID": "1",
                        "Value": chkOpt1
                    },
                    {
                        "ID": "2",
                        "Value": chkOpt2
                    },
                    {
                        "ID": "3",
                        "Value": chkOpt3
                    },
                    {
                        "ID": "4",
                        "Value": chkOpt4
                    }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};

export const getISRB = async () => {
  let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      console.error("❌ Error fetching member info:", member_info.error);
      throw new Error(member_info.error);
    }
    // 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/isrb/get'
    // https://max-api-gateway.azure-api.net/isrb/get
    // Set 'env' to 'prod' or 'test' as needed
    let config = {
      method: 'post',
      url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/isrb/get',
      headers: { 
        'Ocp-Apim-Subscription-Key': ms_isrb_key,
        'Content-Type': 'application/json',
        'env' : 'prod'
      },
      data: {
        "account_number":  member_info.member_number.padStart(10,"0")
      }
    };
    
    const response = await axios(config);
    if (response.status === 200) {
        console.log("ISRB Data Response:", response.data);
        let isrbData = response.data.isrb;
        return isrbData;
    } else {
        return '';
    }
  } catch (error) {
      return '';
  }
};



export const submitChkCreate = async ({selectedChk,chkDeposit,chkFundFrom,chkCardChoice,chkOpt1,chkOpt2,chkOpt3,chkOpt4}) => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
      
      const nexum_body = {
          "Credentials": {
            "AdministrativeCredentials": {
                "Password": nexum_ac
            }
          },
          "Header": {
              "MessageID": "1",
              "RGState": "CHKCREATE"
          },
          "Body": {
              "File": "RHD.SYMX.ADDSHARE.PND",
              "RGSession": 1,
              "UserDefinedParameters": {
                  "RGUserChr": [
                      {
                          "ID": "1",
                          "Value": member_info.member_number.padStart(10,"0")
                      },
                      {
                          "ID": "2",
                          "Value": selectedChk
                      },
                      {
                          "ID": "3",
                          "Value": chkDeposit
                      },
                      {
                          "ID": "4",
                          "Value": chkFundFrom
                      },
                      {
                          "ID": "5",
                          "Value": chkCardChoice
                      }
                  ],
                  "RGUserNum": [
                      {
                          "ID": "1",
                          "Value": chkOpt1
                      },
                      {
                          "ID": "2",
                          "Value": chkOpt2
                      },
                      {
                          "ID": "3",
                          "Value": chkOpt3
                      },
                      {
                          "ID": "4",
                          "Value": chkOpt4
                      }
                  ]
              }
          }
        };
  
      const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
      const response = await axios.post(url, nexum_body, config);
      return JSON.parse(response.data.Body.RGLines);
    } catch (error) {
      throw error;
    }
};